import { useFetchFile, useFileReader } from '@round/utils';
import { Image, Spinner } from '@round/ui-kit';
import styles from './PreviewEvidenceFile.module.css';
import cn from 'classnames';

type Props = {
    url: string | null | undefined;
    className?: string;
};

const PreviewEvidenceFile = ({ url, className }: Props) => {
    const { data, status } = useFetchFile(url);
    const { data: readerData, status: readerStatus } = useFileReader(data);
    const isFileInitialized =
        (status === 'success' || status === 'error') && (readerStatus === 'success' || readerStatus === 'error');

    if (status === 'error' || readerStatus === 'error') {
        return <div className={className}>Unfortunately, we couldn't load the file</div>;
    }

    if (!isFileInitialized) {
        return (
            <div className={className}>
                <Spinner />
            </div>
        );
    }

    if (isFileInitialized && data?.type.startsWith('image')) {
        return (
            <div className={cn(styles.imageContainer, className)}>
                <Image className={styles.image} src={readerData || ''} />
            </div>
        );
    }

    return (
        <div className={className}>
            <video className={styles.video} src={readerData || ''} controls />
        </div>
    );
};

export default PreviewEvidenceFile;
